import actionTypes from './type';

const INIT_DATA_SEARCH = {
  clientStatusId: '',
  clientStatusName: '',
  typeSearch: '',
  keySearch: '',
  isPush: false,
};

const initialState = {
  initializing: false,
  user: null,
  isSearch: false,
  dataSearchByHeader: INIT_DATA_SEARCH,
  isCountSearch: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.APP_INITIALIZING_CHANGED:
      return {
        ...state,
        initializing: action.initializing,
      };
    case actionTypes.USER_CHANGED:
      return {
        ...state,
        user: action.user,
      };
    case actionTypes.OPEN_SEARCH:
      return {
        ...state,
        isSearch: true,
      };
    case actionTypes.CLOSE_SEARCH:
      return {
        ...state,
        isSearch: false,
      };
    case actionTypes.PUSH_DATA_QUERY_SEARCH:
      return {
        ...state,
        isCountSearch: false,
        dataSearchByHeader: action.payload,
      };
    case actionTypes.CLEAR_DATA_QUERY_SEARCH:
      return {
        ...state,
        dataSearchByHeader: INIT_DATA_SEARCH,
      };
    case actionTypes.IS_COUNT_SEARCH:
      return {
        ...state,
        isCountSearch: action.isCount,
      };
    default:
      return state;
  }
}
